import { getCurrentInstance } from 'vue';

export function useVueI18n() {
    const instance = getCurrentInstance();

    if (!instance?.proxy.$i18n) throw new Error('VueI18n instance not found');

    return instance?.proxy.$i18n;
}
